import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
const programs = [{
  age: 'Ages 3-6',
  title: 'Little Dragons',
  benefit: 'Focus, coordination, and listening skills in a fun, playful environment.',
  imageColor: 'bg-blue-100'
}, {
  age: 'Ages 7-12',
  title: 'Kids Martial Arts',
  benefit: 'Confidence, discipline, and bully-proof defense for growing children.',
  imageColor: 'bg-red-100'
}, {
  age: 'Ages 13 & Up',
  title: 'Teens & Adults',
  benefit: 'Get fit, learn self-defense, and relieve stress with high-energy training.',
  imageColor: 'bg-gray-100'
}];
export function ProgramBreakdown() {
  return <Section background="gray" id="programs" data-id="element-107">
      <div className="text-center mb-12" data-id="element-108">
        <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4" data-id="element-109">
          Programs for Every Age
        </h2>
        <p className="text-lg text-gray-600" data-id="element-110">
          Expertly designed curriculum tailored to each developmental stage.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8" data-id="element-111">
        {programs.map((program, idx) => <div key={idx} className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 group" data-id="element-112">
            {/* Image Placeholder */}
            <div className={`h-48 ${program.imageColor} flex items-center justify-center relative overflow-hidden`} data-id="element-113">
              <div className="absolute inset-0 bg-black/5 group-hover:bg-black/0 transition-colors" data-id="element-114" />
              <span className="font-bold text-gray-400 uppercase tracking-widest text-sm" data-id="element-115">
                [{program.title} Image]
              </span>
            </div>

            <div className="p-8" data-id="element-116">
              <span className="inline-block px-3 py-1 bg-gray-100 text-gray-600 text-xs font-bold uppercase tracking-wider rounded-full mb-4" data-id="element-117">
                {program.age}
              </span>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-118">
                {program.title}
              </h3>
              <p className="text-gray-600 mb-6 min-h-[3rem]" data-id="element-119">
                {program.benefit}
              </p>
              <Button variant="outline" fullWidth className="group-hover:bg-gray-900 group-hover:text-white group-hover:border-gray-900" data-id="element-120">
                Try a Free Class
                <ArrowRight className="w-4 h-4 ml-2" data-id="element-121" />
              </Button>
            </div>
          </div>)}
      </div>
    </Section>;
}